var pixels = 70; // number of pixels before fixing the nav

// change styles on scroll
$(window).bind('scroll', function() {
  if ($(window).scrollTop() > pixels) {
    $('.nav-fixed').addClass('active');
  } else {
    $('.nav-fixed').removeClass('active');
  }
});
